import { effect, inject } from '@angular/core';
import { Router } from '@angular/router';
import { InstanceService } from '../centrex/instance.service';

export const InstanceGuard = () => {
    const instanceService = inject(InstanceService);
    const router = inject(Router);

    effect(() => {
        if (instanceService.instance() === null) {
            router.navigate(['/instance']);
            return false;
        } else {
            return true;
        }
    });
    return true;
};
